import styled from "styled-components"
export const ProjectText = styled.div`
  line-height: 1.447em;
  > h1,
  h2,
  h3,
  h4 {
    font-weight: 200;
    font-family: "Velo Sans Display Light It";
    margin-bottom: 20px;
  }

  @media (max-width: 811px) {
    margin-top: -15px;
    padding: 2px 10px 10px 10px;
    font-weight: 100;
  }
`
